import { render } from "./BarChart.vue?vue&type=template&id=6f6eb25c&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=6f6eb25c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6f6eb25c"

export default script